import React, { useEffect, useRef } from 'react';

import classNames from 'classnames';

import { useToast } from 'Hooks/useToast';

import CircleCheckIcon from 'Assets/icons/circle-check.svg';
import CircleInfoIcon from 'Assets/icons/circle-info.svg';
import CircleXMarkIcon from 'Assets/icons/circle-xmark.svg';
import ExclamationTriangleIcon from 'Assets/icons/exclamation-triangle.svg';
import XMarkIcon from 'Assets/icons/xmark.svg';

const toastTypes = {
    success: {
        icon: <CircleCheckIcon className="tw-w-5 tw-h-5 tw-text-green" />,
    },
    warning: {
        icon: <ExclamationTriangleIcon className="tw-w-5 tw-h-5 tw-text-yellow-400" />,
    },
    info: {
        icon: <CircleInfoIcon className="tw-w-5 tw-h-5 tw-text-blue" />,
    },
    error: {
        icon: <CircleXMarkIcon className="tw-w-5 tw-h-5 tw-text-red" />,
    },
};

const Toast = ({ message, type, id, duration = 5000 }) => {
    const toast = useToast();

    const timerRef = useRef(null);

    useEffect(() => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }

        timerRef.current = setTimeout(handleDismiss, duration);
    }, []);

    const handleDismiss = () => {
        toast.remove(id);
    };

    const { icon } = toastTypes[type];

    return (
        <div id={id} className="tw-flex tw-items-center tw-w-full tw-p-4 tw-text-gray-500 tw-bg-white tw-rounded-lg tw-shadow" role="alert">
            <div className="tw-inline-flex tw-items-center tw-justify-center tw-flex-shrink-0">{icon}</div>
            <div
                className={classNames('tw-ms-3 tw-text-sm tw-font-normal', {
                    'tw-text-green': type === 'success',
                    'tw-text-yellow-400': type === 'warning',
                    'tw-text-blue': type === 'info',
                    'tw-text-red': type === 'error',
                })}
                dangerouslySetInnerHTML={{ __html: message }}
            ></div>
            <button
                type="button"
                className="tw-ms-auto -tw-mx-1.5 -tw-my-1.5 tw-bg-white tw-text-gray-400 hover:tw-text-gray-900 tw-rounded-lg focus:tw-ring-2 focus:tw-ring-gray-300 tw-p-1.5 hover:tw-bg-gray-100 tw-inline-flex tw-items-center tw-justify-center tw-h-8 tw-w-8"
                aria-label="Close"
                onClick={handleDismiss}
            >
                <XMarkIcon className="tw-w-2.5 tw-h-2.5" />
            </button>
        </div>
    );
};

export default Toast;
